import type { UseClaimPermissionsDeps, UseSessionMembershipDeps, UseSignedInDeps } from '@/types/session/sessionTypes'
import { useClaimPermissions as useClaimPermissionsShell } from './shell/useClaimPermissions'
import { useSessionMembership as useSessionMembershipShell } from './shell/useSessionMembership'
import { useSignedIn as useSignedInShell } from './shell/useSignedIn'

// ============================================================================
// Coordinator surface
//
// Who the visitor is, as the app chrome and the landing page need it. This domain stays
// light on purpose: it imports neither the wallet stack nor zod nor the member shells, so
// the header and the landing page can read the session without loading them.
// ============================================================================

/** Whether the visitor is signed in with the wallet connected now. */
export function useSignedIn(deps: UseSignedInDeps = {}) {
  return useSignedInShell(deps)
}

/** The signed-in user's membership record, shared with the member domain's queries. */
export function useSessionMembership(deps: UseSessionMembershipDeps = {}) {
  return useSessionMembershipShell(deps)
}

/** Whether the signed-in user may run distributions. */
export function useClaimPermissions(deps: UseClaimPermissionsDeps = {}) {
  return useClaimPermissionsShell(deps)
}
